var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[ _vm.absolute ? 'block-ui-n' : '' ]},[_c('div',{staticClass:"spinner-n",class:[ _vm.absolute ? 'absolute-n' : 'relative-n' ]},[_c('div',{staticClass:"double-bounce1-n",style:({ 'background-color': _vm.backgroundColor })}),_vm._v(" "),_c('div',{staticClass:"double-bounce2-n",style:({ 'background-color': _vm.backgroundColor })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }